import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiService } from './api/api.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http'
import { HttpHeaderInterceptor } from './interceptor/http-header.interceptor';
import { HttpErrorInterceptor } from './interceptor/http-error.interceptor';
import { HttpResponseInterceptor } from './interceptor/http-response.interceptor';
import { SocketIoClientService } from './socket-io-client/socket-io-client.service';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import {EnvironmentService} from "./api/environment.service";
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot()
  ],
  providers: [
    ApiService,
    EnvironmentService,
    SocketIoClientService,
    { provide: HTTP_INTERCEPTORS, useClass: HttpHeaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpResponseInterceptor, multi: true }
  ]
})
export class CoreModule { }
